import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="border-t-2 border-bg-tertiary mt-auto" role="contentinfo">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center text-sm" style={{ color: 'var(--text-secondary)' }}>
          <span>© {new Date().getFullYear()} SensorMediaHub. All rights reserved.</span>
          <Link
            to="/help/welcome"
            className="underline focus:outline-none focus:ring-2 focus:ring-offset-2 rounded"
            style={{ color: 'var(--text-secondary)' }}
          >
            Help
          </Link>
          <Link
            to="/about"
            className="underline focus:outline-none focus:ring-2 focus:ring-offset-2 rounded"
            style={{ color: 'var(--text-secondary)' }}
          >
            About
          </Link>
          <Link
            to="/privacy-policy"
            className="underline focus:outline-none focus:ring-2 focus:ring-offset-2 rounded"
            style={{ color: 'var(--text-secondary)' }}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  )
}

